const urlSearchParameters = new URLSearchParams(window.location.search);
export default class UrlParameters{
	static get salesforce(){
		return urlSearchParameters.has('salesforce')?true:false;
	}
	static get noWelcomePage(){
		return urlSearchParameters.has('nowelcomepage')?true:false;
	}
}